export enum VerticalPositions {
  top = 'top',
  bottom = 'bottom',
}
